import React from "react"

import { localizer } from "../../Translator"

import { Grid, Typography } from "@material-ui/core"
import { Backdrop, CircularProgress } from "@material-ui/core"

import OutboxCli from "../../sdk/OutboxCli"

export class MultiImageViewer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // Shipment page list containing the pages of all the documents
      documentpages: [],

      // Number document page requested to be displayed
      pagenumber: 1,

      // Image content represents in base64 format
      base64: "",

      // Width and height in pixels given to the viewer. The displayed background image will be resized to this width and heigth.
      viewerWidth: 0,
      viewerHeight: 0,

      //error message to display in case of api calls fail
      errormessage: null,

      isLoading: false
    }
  }
  
  componentDidMount() {
    if (this.props) {

      let documentpages = []
      for (let i = 0; i < this.props.documentpages.length; i++) {
        const pages = this.props.documentpages[i];
        for (let j = pages.pageFirst; j <= pages.pageLast; j++) {
          const singlepage = { documentid: pages.draftId, pagenumber: j }
          documentpages.push(singlepage)
        }
      }
      
      this.setState({
        documentpages: documentpages,
        pagenumber: this.state.pagenumber,
        viewerWidth: this.props.viewerWidth,
        viewerHeight: this.props.viewerHeight
      },
        () => {
          this.getPage()
          this.handleisLoading()
        })
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props === prevProps) return

    let documentpages = []
    for (let i = 0; i < this.props.documentpages.length; i++) {
      const pages = this.props.documentpages[i];
      for (let j = pages.pageFirst; j <= pages.pageLast; j++) {
        const singlepage = { documentid: pages.draftId, pagenumber: j }
        documentpages.push(singlepage)
      }
    }
      
    this.setState({
      documentpages: documentpages,
      pagenumber: this.state.pagenumber,
      viewerWidth: this.props.viewerWidth,
      viewerHeight: this.props.viewerHeight
    },
      () => {
        this.getPage()
      })
  }

  /**
   * Returns base64 of a page and draft requested
   */
  getPage = () => {

    if (this.state.documentpages.length < this.state.pagenumber) return
    this.setState({ isLoading: true })
    let page = this.state.documentpages[this.state.pagenumber - 1]
    
    OutboxCli.GetDraftPageImage(page.documentid, page.pagenumber, 0, 0, 100, 100).then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ errormessage: response.substring(response.indexOf(' ')) })
      } else {
        this.setState({ base64: response, errormessage: null })
      }

      this.setState({ isLoading: false })
    })
  }

  /**
   * Loading the previous page that it has to be displayed. If it is in the first page, it doesnt do anything
   */
  previousPage = () => {
    if (this.state.pagenumber > 1) {
      let pagenumber = this.state.pagenumber
      this.setState({ pagenumber: --pagenumber },
        () => {
          this.getPage()
        }
      )
    }
  }

  /**
   * Loading the next page that it has to be displayed. If there are no more pages, it doesnt do anything
   */
  nextPage = () => {
    if (this.state.pagenumber < this.state.documentpages.length) {
      let pagenumber = this.state.pagenumber
      this.setState({ pagenumber: ++pagenumber },
        () => {
          this.getPage()
        }
      )
    }
  }
  /**
   * To indicate that the draft has already been loaded
  */
  handleisLoading = () => {
    const { handleisLoadingDraft } = this.props
    handleisLoadingDraft()
  }

  render() {
    return (
      <React.Fragment>

        <Grid container direction="row" spacing={2} alignItems="center" justify="center">

          <Grid container item md={12} justify="center">
            <img className="viewer-container" src={"data:image/png;base64, " + this.state.base64} alt="" width={this.state.viewerWidth} height={this.state.viewerHeight}></img>
          </Grid>
          <Grid container item md={12} justify="center">
            <i className="fa-solid fa-caret-left font-size-25 cursor-pointer" onClick={this.previousPage}></i>
            <Typography className="typography-generic"> {localizer.Page + " " + this.state.pagenumber + " " + localizer.Of + " " + this.state.documentpages.length} </Typography>
            <i className="fa-solid fa-caret-right font-size-30 cursor-pointer" onClick={this.nextPage}></i>
          </Grid>

        </Grid>

        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 1350 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }

      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Utilities/MultiImageViewer.js